/* ==========================================================================
   CSA Testimonials Carousel JavaScript
   Full Shopify Theme Editor (Customizer) Realtime Sync & Lifecycle Management
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  initCSATestimonialsSliders();
});

/* Listen for all Shopify Theme Editor events to provide instant realtime updates */
document.addEventListener('shopify:section:load', function (event) {
  if (event.target.classList.contains('section-csa-testimonials') || event.target.querySelector('.csa-testimonials-swiper')) {
    initCSATestimonialsSection(event.target);
  }
});

document.addEventListener('shopify:section:unload', function (event) {
  if (event.target.classList.contains('section-csa-testimonials') || event.target.querySelector('.csa-testimonials-swiper')) {
    destroyCSATestimonialsSection(event.target);
  }
});

document.addEventListener('shopify:block:select', function (event) {
  const blockEl = event.target;
  const sectionEl = blockEl.closest('.csa-testimonials-section');
  if (sectionEl) {
    const swiperEl = sectionEl.querySelector('.csa-testimonials-swiper');
    if (swiperEl && swiperEl.swiperInstance) {
      const slideIndex = Array.from(swiperEl.querySelectorAll('.swiper-slide')).indexOf(blockEl);
      if (slideIndex !== -1) {
        swiperEl.swiperInstance.slideTo(slideIndex);
      }
    }
  }
});

function destroyCSATestimonialsSection(section) {
  const swiperEl = section.querySelector('.csa-testimonials-swiper');
  if (swiperEl && swiperEl.swiperInstance) {
    swiperEl.swiperInstance.destroy(true, true);
    swiperEl.swiperInstance = null;
    swiperEl.dataset.initialized = 'false';
  }
}

function initCSATestimonialsSliders() {
  const sections = document.querySelectorAll('.csa-testimonials-section');
  sections.forEach(function (section) {
    initCSATestimonialsSection(section);
  });
}

function initCSATestimonialsSection(section) {
  const swiperEl = section.querySelector('.csa-testimonials-swiper');
  if (!swiperEl) return;

  // Clean up previous Swiper instance if re-loaded in Theme Editor
  if (swiperEl.swiperInstance) {
    swiperEl.swiperInstance.destroy(true, true);
    swiperEl.swiperInstance = null;
  }

  const prevBtn = section.querySelector('.csa-testi-prev');
  const nextBtn = section.querySelector('.csa-testi-next');
  const paginationEl = section.querySelector('.csa-testi-pagination');

  if (typeof Swiper !== 'undefined') {
    const swiperInstance = new Swiper(swiperEl, {
      slidesPerView: 1.25,
      spaceBetween: 14,
      grabCursor: true,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      resizeObserver: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        600: {
          slidesPerView: 2.2,
          spaceBetween: 16,
        },
        850: {
          slidesPerView: 3.2,
          spaceBetween: 18,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    });

    swiperEl.swiperInstance = swiperInstance;
    swiperEl.dataset.initialized = 'true';

    // Force layout update after DOM rendering
    setTimeout(function () {
      if (swiperInstance && !swiperInstance.destroyed) {
        swiperInstance.update();
      }
    }, 100);
  }
}
